import React from 'react';

import PageTitle from '../common/PageTitle';
import SingleImport from '../common/SingleImport';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const SingleProductsImport = (props) => {
  const { t } = useAutoTranslation();
  return (
    <>
      <PageTitle title={t('Импорт товаров')} />

      <SingleImport
        templateType="SKU"
        templateFileName="ItemTemplate"
        successMessage={t('Задание на импорт товаров создано успешно')}
        successRoute="/imports"
        errorMessage={t('Ошибка создания задания на импорт товаров')}
      />
    </>
  );
};

export default SingleProductsImport;
